import { defineStore } from 'pinia'
import userService from '@/services/user-service'

export default defineStore({
    id: 'auth',
    state: () => ({
        token: null,
        currentUser: {}
    }),
    getters: {
        getToken: (state) => state.token,
        getCurrentUser: (state) => state.currentUser
    },
    actions: {
        setToken(token) {
            this.token = token
            if (token) {
                userService.getCurrentUser().then((resp) => {
                    this.currentUser = resp.data
                })
            }
        }
    }
})
